export default __webpack_public_path__ + "static/media/album.0201ef81.png";